import React, { useContext } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';

import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


import jobIcon from "../../img/ticket-icon-orange.svg";
import messageIcon from "../../img/message-icon.svg";
import profilePhoto from "../../img/base-profile-photo.svg";
import helpIcon from "../../img/Help-icon.svg";
import signOut from "../../img/sign-out.svg";


import AppContext from '../../context/AppProvider';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../features/auth/authSlice';


const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 150,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));



export default function DropdownAppBarMobile() {
  const { currentJob } = useContext(AppContext);
  const user = useSelector(selectCurrentUser);
  
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event, value) => {
    setAnchorEl(null);
    if (value === "LogOut") {
      localStorage.removeItem("accessToken");
      window.location.href = '/';
    }
  };

  let history = useHistory()

  const handleJIPClick = () => {
    let jobId = currentJob.id;
    history.push("/dashboard/job/" + jobId)
  }

  return (
    <div className="navbar-top-items">

      <Button
        id="demo-customized-button"
        aria-controls="demo-customized-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        sx={{ color: '#4f4f4f' }}
      >
        <img src={profilePhoto} alt="Profile Icon" height="32px" width='32px' />
      </Button>

      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleClose} disableRipple sx={{ borderBottom: '2px solid var(--background-lightgray)' }}
          component={Link} to='/dashboard/home?tab_index=0' >
          {user.screenName}
        </MenuItem>

        {currentJob ?
          <MenuItem onClick={handleJIPClick} sx={{ color: 'var(--orange)', fontWeight: '700' }}>
            <img src={jobIcon} alt="Job Icon" height="24px" style={{ marginRight: '1em' }} />
            Job In Progress
          </MenuItem>
          : null}

        {/* <MenuItem>
          <img src={messageIcon} alt="Message Icon" height="24px" style={{ marginRight: '1em' }} />
          Message
        </MenuItem> */}

        {/* <MenuItem onClick={handleClose} disableRipple>
          <img src={helpIcon} alt="Help Icon" height="24px" width="24px" style={{ marginRight: '1em' }} />
          Help
        </MenuItem> */}

        <MenuItem onClick={(event) => handleClose(event, "LogOut")} disableRipple>
          <img src={signOut} alt="Sign Out Icon" height="24px" width="24px" style={{ marginRight: '1em' }} />
          Log Out
        </MenuItem>

      </StyledMenu>

    </div>
  );
}